import React, { useState } from "react";
import styled from "styled-components";

// Styled components for layout and design
const Container = styled.div`
  font-family: Arial, sans-serif;
  background-color: #fff;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  text-align: center;
  color: #006a71;
`;

const Description = styled.p`
  text-align: center;
  color: #555;
  margin-bottom: 20px;
`;

const InputField = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #d32f2f;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: #c13535;
  }
`;

const ConfirmationText = styled.p`
  text-align: center;
  color: #555;
  font-size: 14px;
  margin-top: 15px;
`;

const ErrorMessage = styled.p`
  color: red;
  text-align: center;
  font-size: 14px;
`;

const AccountDelete = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleDeleteRequest = () => {
    setIsLoading(true);
    setError("");

    // Validate email and password
    if (!email || !password) {
      setError("Please enter both your email and password.");
      setIsLoading(false);
      return;
    }

    // Simulating an API request to delete the account
    setTimeout(() => {
      // Simulate successful deletion
      setIsLoading(false);
      alert("Your account has been successfully deleted.");
      // You can add an actual API call here to delete the account
    }, 2000);
  };

  return (
    <Container>
      <Title>Delete Your Account</Title>
      <Description>
        We're sorry to see you go. If you're sure you want to delete your
        account, please provide your email and password below.
      </Description>

      {isConfirmed ? (
        <>
          <InputField
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <InputField
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <ConfirmationText>
            Are you sure you want to permanently delete your account? This
            action cannot be undone.
          </ConfirmationText>
          <Button onClick={handleDeleteRequest} disabled={isLoading}>
            {isLoading ? "Processing..." : "Yes, Delete My Account"}
          </Button>
        </>
      ) : (
        <Button onClick={() => setIsConfirmed(true)}>
          Request Account Deletion
        </Button>
      )}
    </Container>
  );
};

export default AccountDelete;
